import {_ReactPixi, Container, NineSlicePlane, Text} from '@pixi/react';
import {AdjustmentFilter, OutlineFilter} from 'pixi-filters';
import {Assets, FederatedEventHandler, FederatedPointerEvent} from 'pixi.js';
import {PropsWithChildren, useCallback, useMemo, useState} from 'react';
import {GREEN_BUTTON} from '../assetManifest';
import {textStyle} from '../constants';
import {useGameTimeExpired} from '../hooks/useGameTimeExpired';
import {useIsGameStarted} from '../state/GameTimerSlice';

interface ButtonProps extends PropsWithChildren<_ReactPixi.IContainer> {
    label: string;
    onclick?: FederatedEventHandler;
    enabled?: boolean;
}

const monochrome = new AdjustmentFilter({saturation:0, brightness:2.4});
const dark = new AdjustmentFilter({saturation:0, brightness:1});
const brighten = new AdjustmentFilter({brightness:1.2});
const outline =  new OutlineFilter(2);

export function Button({label, enabled = true, onclick, ...others}: ButtonProps) {
    const gameTimerStarted = useIsGameStarted();
    const gameTimerExpired = useGameTimeExpired();
    const [hoverActive, setHoverActive] = useState<boolean>(false);

    const width: number = (Object.hasOwn(others, 'width') && others.width) ? others.width : 180;
    const height: number = (Object.hasOwn(others, 'height') && others.height) ? others.height : 60;

    const handleClick = useCallback((e: FederatedPointerEvent)=>{
        if (gameTimerStarted && !gameTimerExpired && enabled && onclick)
            onclick(e);
    }, [enabled, onclick]);

    const filters = useMemo(() => {
        if (!enabled)
            return [monochrome];
        if (!gameTimerStarted || gameTimerExpired)
            return [dark];
        if (hoverActive)
            return [outline, brighten];
        return [];
    }, [gameTimerStarted, enabled, hoverActive]);

    return (
        <Container {...others}
            onclick={handleClick}
            width={width} height={height}
            eventMode={'static'}
            onmouseover={() => setHoverActive(true)}
            onmouseleave={() => setHoverActive(false)}
            anchor={0.5}
        >
            <NineSlicePlane texture={Assets.get(GREEN_BUTTON)}
                leftWidth={5} topHeight={5} rightWidth={5} bottomHeight={5}
                width={width} height={height}
                filters={filters}
            />
            <Text text={label}
                style={textStyle({fill: enabled ? ['#000', '#555'] : ['#bbb'], wordWrap: true, wordWrapWidth: 200, fontSize: 24})}
                x={width / 2} y={height / 2} anchor={0.5}/>
        </Container>
    );
}